import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { errorActions } from 'features/error';

const useError = () => {
  const dispatch = useDispatch();
  
  const showError = useCallback(error => dispatch(errorActions.setError(error)), [dispatch]);
  const hideError = useCallback(() => dispatch(errorActions.hideError()), [dispatch]);

  const setError = useCallback((error) => new Promise(resolve => {
    resolve(showError(error));
  }), [showError]);

  return { setError, hideError };
};

export default useError;